module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAy0lEQVRIie3WsWsCMRiG8Z+DSsWhtEI37ShCoUs7iIPQpUMRDy0IguhkdSqdW+jWf9vBDGIvw3knONwLD4TvS/KELAkXkCsM8XLEENUiBE3MsThijusiBLlTQ+NM1OAbf2fiB+7QxReSMM7DKtDF/eFVfaCf6XLTkwT+JSZooZNSb4debkE/siCJzC8FpaAUnCB4wiil/obnIgRZExWsMShAMME4rfFu/xTmSQWfIge9xS9meEAvI49YBkH0M3CDKTbYZmSNV9QPN9wBYzY+yFJvMn4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete1.png
// module id = fr/G
// module chunks = 1